import React, { useState, useEffect } from 'react';
import './FarmerHero.css';

// ── Farmer slides data ──
// Replace image URLs with your own stored in /storage/farmer-images/
const FARMER_SLIDES = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=1400&q=80',
    label: 'Harvest Season',
    headline: 'From Our Farms,',
    sub:      'To Your Table',
    caption:  'Fresh harvests from verified farmers across South India',
    tag:      '🌾 Wheat & Grains',
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1592991538534-00572c8a3f23?w=1400&q=80',
    label: 'Organic Farming',
    headline: 'Grown with',
    sub:      'Love & Care',
    caption:  'Zero chemicals. 100% organic. Sourced direct from farmers.',
    tag:      '🥬 Vegetables',
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=1400&q=80',
    label: 'Daily Harvest',
    headline: 'Fresh Every',
    sub:      'Single Day',
    caption:  'Our farmers harvest daily so you always get the freshest produce.',
    tag:      '🍅 Fresh Produce',
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=1400&q=80',
    label: 'Sustainable Farming',
    headline: 'Growing for',
    sub:      'Tomorrow',
    caption:  'Supporting sustainable agriculture and local farming communities.',
    tag:      '🌱 Sustainable',
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=1400&q=80',
    label: 'Community Farms',
    headline: '200+ Farmer',
    sub:      'Families with Us',
    caption:  'Every purchase directly supports a farmer family in Tamil Nadu.',
    tag:      '👨‍👩‍👧 Community',
  },
];

const FarmerHero = ({ onShopNow }) => {
  const [active,    setActive]    = useState(0);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState('next'); // 'next' | 'prev'

  // Auto-advance slides every 5s
  useEffect(() => {
    const timer = setInterval(() => goTo('next'), 5000);
    return () => clearInterval(timer);
  }, [active]);

  const goTo = (dir, idx = null) => {
    if (animating) return;
    setAnimating(true);
    setDirection(dir === 'next' ? 'next' : 'prev');
    setTimeout(() => {
      if (idx !== null) {
        setActive(idx);
      } else {
        setActive(prev =>
          dir === 'next'
            ? (prev + 1) % FARMER_SLIDES.length
            : (prev - 1 + FARMER_SLIDES.length) % FARMER_SLIDES.length
        );
      }
      setAnimating(false);
    }, 500);
  };

  const slide = FARMER_SLIDES[active];

  return (
    <section className="fh-root">
      {/* BACKGROUND IMAGE LAYER */}
      <div className={`fh-bg-wrap ${animating ? `fh-${direction}` : ''}`}>
        {FARMER_SLIDES.map((s, i) => (
          <div
            key={s.id}
            className={`fh-bg-slide ${i === active ? 'active' : ''}`}
            style={{ backgroundImage: `url(${s.image})` }}
          />
        ))}
        <div className="fh-overlay" />
      </div>

      {/* CONTENT */}
      <div className={`fh-content ${animating ? 'fh-content-exit' : 'fh-content-enter'}`}>
        <div className="fh-tag">{slide.tag}</div>
        <div className="fh-eyebrow">{slide.label}</div>
        <h2 className="fh-headline">
          {slide.headline}<br />
          <span className="fh-accent">{slide.sub}</span>
        </h2>
        <p className="fh-caption">{slide.caption}</p>
        <div className="fh-actions">
          <button className="fh-cta-primary" onClick={onShopNow}>
            Shop Fresh Products →
          </button>
          <button className="fh-cta-secondary">
            Meet Our Farmers
          </button>
        </div>
      </div>

      {/* NAVIGATION ARROWS */}
      <button className="fh-arrow fh-arrow-left"  onClick={() => goTo('prev')}>‹</button>
      <button className="fh-arrow fh-arrow-right" onClick={() => goTo('next')}>›</button>

      {/* DOTS */}
      <div className="fh-dots">
        {FARMER_SLIDES.map((_, i) => (
          <button
            key={i}
            className={`fh-dot ${i === active ? 'active' : ''}`}
            onClick={() => goTo(i > active ? 'next' : 'prev', i)}
          />
        ))}
      </div>

      {/* SLIDE COUNTER */}
      <div className="fh-counter">
        {String(active + 1).padStart(2, '0')} / {String(FARMER_SLIDES.length).padStart(2, '0')}
      </div>

      {/* BOTTOM STATS BAR */}
      <div className="fh-stats-bar">
        {[
          { num: '200+', label: 'Verified Farmers' },
          { num: '50+',  label: 'Product Varieties' },
          { num: '4.8★', label: 'Average Rating' },
          { num: '2-Day', label: 'Delivery' },
        ].map(({ num, label }) => (
          <div key={label} className="fh-stat">
            <span className="fh-stat-num">{num}</span>
            <span className="fh-stat-label">{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FarmerHero;